<template>
  <div class="home">
      <div class="container">
          <br>
          <p class="display-2 font-weight-thin">Impressum</p>
          <br>
          <p class="ml-6 font-weight-bold">Yuanyuan Wan <br> Geschäftsführerin</p>
          <p class="ml-6">Café am Platz<br>Am Platz 6, 1130 Wien, Österreich <br>+43 1 8779338 </p>
          <p class="ml-6">cafeamplatz6@gmail.com</p>
          <p class="ml-6">KA-FE Betriebsges.m.b.H</p>
          <p class="ml-6">UID ATU 15690009</p>
          <p class="ml-6">Mitglied der WKÖ</p>
          <p class="ml-6">Gewerbebehörde: Magistratisches Bezirksamt 13. Bezirk und MA 63</p>
          <p class="ml-6">Sämtlich auf unseren Seiten enthaltenen Text, Bilder und Informationen im generellen stellen keine Aufforderung, keine Grundlage
              oder Empfehlung zur Anwendung oder Nichtanwendung jedweger Technologie oder Verfahren. Des Weiteren kann keine Garantie für Richtigkeit,
              Vollständigkeit und Aktualität der Angaben übernommen werden.
              <br>
              Infolgedessen sind die Text, Bilder und Informationen im allgemeinen keine Grundlage für einen Vertrag oder eine Verpflichtung, welcher Art auch immer.
              <br> Es wird im Weiteren keine Haftung für die Folgen, insbesondere Verluste,
              die sich auf Basis der bereitgestellten Texte, Bilder und Informationen im allgemeinen und darin enthaltenen Ansichten und Rückschlüssen
              ergeben bzw. ergeben könnten, übernommen.
              <br>
                Café am Platz übernimmt keine Verantwortung, Gewährleistung oder Haftung für die Inhalte von externen Websites, die über Links von dieser Website erreicht werden können, da
                die ständige inhaltliche Überprüfung aller Links nicht möglich ist.
          </p>
          <p class="ml-6 font-weight-bold"><u>Leon Zhang</u>       
          <v-btn icon
            href="https://www.instagram.com/leeon.zhg/?hl=de">
            <v-icon
                >mdi-instagram
            </v-icon>
      </v-btn> 
      <br> Webdesign und Konzep</p>
          <p class="ml-6 font-weight-bold"><u>Leon Zhang</u>
                    <v-btn icon
            href="https://www.instagram.com/leeon.zhg/?hl=de">
            <v-icon
                >mdi-instagram
            </v-icon>
      </v-btn> 
           <br> Photography</p>
          <p class="ml-6">Alle Bilder und Logos auf der Website unterliegen dem Urheberrecht. Somit dürfen die Bilder in welcher Art und Weise auch
              immer nicht von eine andere Person außer der Urheber selbst verwendet werden. </p>
          <p class="ml-6 font-weight-bold">Copyright © Café am Platz</p>

      </div>
  </div>
</template>

<script>
export default {
      methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
